<script>
  import { formatMoney, ignore } from '../../Common/tools';
  import { onMount } from 'svelte';
  import ConfirmAddon from './ConfirmAddon.svelte';
  import { fly } from 'svelte/transition';
  import { External, M } from '../../external';
  import { ADDON_VIDEOS_LIMIT, disableAddon, formatNumber } from './addons';

  export let onChange = ignore, onCanceled = ignore, addon = null, subscription, showLimitsReachedMessage = false;
  let addons = [];
  let confirming = false;
  let initialValue = -1;

  let planLimit = subscription.planDetailsNoAddons['videos'];
  let canUseWithoutAddon = planLimit > 0;

  let addonVideos = {
    '-1': canUseWithoutAddon ? planLimit : 0
  }

  for(let idx = 1; idx < ADDON_VIDEOS_LIMIT.length; ++idx) {
    addonVideos['' + idx] = ADDON_VIDEOS_LIMIT[idx];
  }

  let select = async (selected) => {
    if (selected.value === -1) {
      let result = await disableAddon(selected);
      if (result) {
        onChange(result);
      }
    } else {
      addon = selected;
      confirming = true;
    }
  };

  onMount(() => {
    addons = [
      { value: -1, monthlyPrice: 0, type: 'VIDEO' },
      ...External.Website.addons.filter(addon => addon.type === 'VIDEO').sort((a, b) => {
        const [left, right] = [addonVideos['' + a.value], addonVideos['' + b.value]];
        return left === right ? a.monthlyPrice - b.monthlyPrice : left - right;
      })
    ];
    if (!addon) {
      addon = subscription.addons.find(addon => addon.type === 'VIDEO');
      if (!addon) {
        addon = addons[0];
      }
    }
    initialValue = addon.value;
  });
</script>
<div class="popup-widget-wrapper" style="overflow-x: hidden">

  <div class="col20 f-left t-left flex align-center flex-col">
    <h2 class="col20 f-left mt-15 t-center big-title-popup">{M.VIDEO_HOSTING}</h2>
    {#if showLimitsReachedMessage}
      <h4 class="col20 f-left mt-15 t-center big-title-popup">{M.RESOURCE_LIMIT_REACHED}</h4>
    {/if}
    <div class="col12 f-left t-center mt-10 light-gray-text f-14-regular">{M.EXTRA_VIDEO_DESC}</div>
  </div>

  {#if confirming}
    <div class="col20 f-left" in:fly={{x: '100%'}}>
      <ConfirmAddon {addon} currency={subscription.currency} value={addon.value} taxRate={subscription.activeVatPercent}
                    on:cancel={() => confirming = false}
                    on:confirm={(event) => onChange(event.detail)} />
    </div>
  {:else}
    <div class="price-tables-wrapper col20 f-left mt-15" in:fly={{x: '-100%'}}>
      {#each addons as addon, index}
        <div class="price-table"
             class:most-popular={initialValue === addon.value}
             class:highlight-table={initialValue === addon.value}
             class:current-plan={initialValue === addon.value}
        >
          <div class="price-table-inner">
            {#if initialValue === addon.value}
              <div class="badge">{M.CURRENT_PLAN}</div>
            {/if}
            <h4 class="price-table-name">{index === 0 ? M.FREE : External.format(M.TIER, 'x', index)}</h4>
            <h3 class="price-table-value monthly">
              {@html formatMoney(addon.monthlyPrice, subscription.currency, true, true)}<span class="price-table-period">/{M.MONTH}
              {#if subscription.activeVatPercent && addon.monthlyPrice > 0}
                <span class="col20 f-left mt-5 price-table-support-text">{M.TAX_PLUS}</span>
              {/if}
            </span>
            </h3>
            <div class="price-table-description">
              <ul class="icon-list-wrapper">
                <li class="icon-list-item" class:disabled={addonVideos['' + addon.value] === 0}>
                  {#if addonVideos['' + addon.value] === 0}
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
                      <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
                    </svg>
                  {:else}
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                      <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                    </svg>
                  {/if}
                  <span class="icon-list-name">
                    {formatNumber(addonVideos['' + addon.value], '', M.X_VIDEOS, M.UNLIMITED_VIDEOS)}
                  </span>
                </li>
                <li class="icon-list-item" class:disabled={addonVideos['' + addon.value] === 0}>
                  {#if addonVideos['' + addon.value] === 0}
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
                      <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
                    </svg>
                  {:else}
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                      <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                    </svg>
                  {/if}
                  <span class="icon-list-name">
                    {M.ANALYTICS}
                  </span>
                </li>
                <li class="icon-list-item" class:disabled={addonVideos['' + addon.value] === 0}>
                  {#if addonVideos['' + addon.value] === 0}
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
                      <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
                    </svg>
                  {:else}
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                      <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                    </svg>
                  {/if}
                  <span class="icon-list-name">{M.VIDEO_TRIGGERS_FLOWS}</span>
                </li>
                <li class="icon-list-item" class:disabled={addonVideos['' + addon.value] === 0}>
                  {#if addonVideos['' + addon.value] === 0}
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
                      <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
                    </svg>
                  {:else}
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                      <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                    </svg>
                  {/if}
                  <span class="icon-list-name">{M.VIDEO_ACTION_TRACKING}</span>
                </li>
                <li class="icon-list-item {addon.value}" class:disabled={addon.value === -1}>
                  {#if addon.value === -1}
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
                      <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
                    </svg>
                  {:else}
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                      <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z"></path>
                    </svg>
                  {/if}
                  <span class="icon-list-name">{M.VIDEO_OVERLAYS_ACTIONS}</span>
                </li>
              </ul>
            </div>
            <div class="price-table-footer">
              <a class="price-table-button" on:click={() => select(addon)}>
                {#if addon.value < initialValue}
                  {M.CHANGE}
                {:else}
                  {M.ACTIVATE_NOW}
                {/if}
                <svg xmlns="http://www.w3.org/2000/svg" class="price-table-arrow" height="48" viewBox="0 -960 960 960" width="48">
                  <path
                    d="m695.461-314.463-32.615-31.999 109.847-110.231H140.001v-45.383h633.692L663.462-611.923l31.614-31.999 164.923 164.537-164.538 164.922Z"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      {/each}
    </div>
  {/if}
</div>
